import { Component } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { GenericLinkDirective } from '@core/jss-utils';

import type { HeaderSize } from '../../basic-content-settings.model';
import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { BasicContentPartialHeadingComponent } from '../../partials/basic-content-partial-heading/basic-content-partial-heading.component';

@Component({
  selector: 'wl-basic-content-variant-ng-content-between',
  templateUrl: './basic-content-variant-ng-content-between.component.html',
  styleUrls: ['./basic-content-variant-ng-content-between.component.ed.scss'],
  standalone: true,
  imports: [
    BasicContentPartialHeadingComponent,
    JssModule,
    NgClass,
    RichTextWrapperComponent,
    GenericLinkDirective,
  ],
})
export class BasicContentVariantNgContentBetweenComponent extends BasicContentVariantInheritableComponent {
  override get headingSize(): HeaderSize {
    return 'h2';
  }
  override get subheadingSize(): HeaderSize {
    return 'h3';
  }

  get hasButtons() {
    return (
      this.content?.buttons?.primary?.link?.href ||
      this.content?.buttons?.secondary?.link?.href
    );
  }

  get hasTopItems() {
    return (
      this.content?.heading?.text?.value ||
      this.content?.subheading?.text?.value ||
      this.content?.text?.text?.value
    );
  }

  get hasBottomItems() {
    return this.hasButtons || this.content?.microcopy?.text?.value;
  }
}
